import { render, staticRenderFns } from "./TemplatePanel.vue?vue&type=template&id=1038ec0e&scoped=true"
import script from "./TemplatePanel.vue?vue&type=script&lang=js"
export * from "./TemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./TemplatePanel.vue?vue&type=style&index=0&id=1038ec0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038ec0e",
  null
  
)

export default component.exports